import { Routes, Route } from "react-router-dom";
import StudiesList from "./StudiesList";
import StudyForm from "./StudyForm";

export default function StudiesRoutes() {
  return (
    <Routes>
      <Route index element={<StudiesList />} />
      <Route path="new" element={<StudyForm />} />
      <Route path=":id/edit" element={<StudyForm />} />
    </Routes>
  );
}
